import { useEffect, useState } from "react";
import { getMarketSocialProof } from "../lib/api";

const SOCIAL_PROOF_ERROR = "Could not load market social proof.";

export function reusableSocialProofData(previousData, marketId) {
  return previousData?.marketId === marketId ? previousData : null;
}

export function buildSocialProofLoadingState(previous, marketId) {
  const data = reusableSocialProofData(previous?.data, marketId);

  return {
    status: data ? "refreshing" : "loading",
    data,
    error: ""
  };
}

export function buildSocialProofErrorState(previous, marketId, error) {
  const data = reusableSocialProofData(previous?.data, marketId);

  return {
    status: "error",
    data,
    error: error?.message || SOCIAL_PROOF_ERROR
  };
}

export function useMarketSocialProof(market) {
  const marketId = String(market?.id || "");
  const refreshKey = [
    marketId,
    Number(market?.totalVotes || 0).toFixed(2),
    ...(market?.options || []).map((option) => `${option.id}:${Number(option.votes || 0).toFixed(2)}`)
  ].join(":");
  const [state, setState] = useState({
    status: "idle",
    data: null,
    error: ""
  });

  useEffect(() => {
    if (!marketId) {
      setState({ status: "idle", data: null, error: "" });
      return;
    }

    let cancelled = false;
    setState((previous) => buildSocialProofLoadingState(previous, marketId));

    getMarketSocialProof(marketId)
      .then((data) => {
        if (cancelled) return;
        setState({ status: "ready", data, error: "" });
      })
      .catch((error) => {
        if (cancelled) return;
        setState((previous) => buildSocialProofErrorState(previous, marketId, error));
      });

    return () => {
      cancelled = true;
    };
  }, [marketId, refreshKey]);

  return state;
}
